import React, { useEffect, useState } from 'react';
import './Toast.scss';

const Toast = ({
  id,
  message,
  type = 'info',
  position = 'top-right',
  duration = 4000,
  showProgress = true,
  closable = true,
  backgroundColor,
  textColor,
  borderColor,
  icon,
  onClose,
  onClick,
  className = '',
  style = {}
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    setIsVisible(true);
    
    if (duration > 0) {
      const progressInterval = setInterval(() => {
        setProgress(prev => {
          const newProgress = prev - (100 / (duration / 100));
          return newProgress <= 0 ? 0 : newProgress;
        });
      }, 100);

      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => {
        clearInterval(progressInterval);
        clearTimeout(timer);
      };
    }
  }, [duration]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => onClose?.(id), 300);
  };

  const getIcon = () => {
    if (icon) return icon;
    
    const icons = {
      success: '✓',
      error: '✕',
      warning: '⚠',
      info: 'ℹ'
    };
    return icons[type] || icons.info;
  };

  const customStyles = {
    backgroundColor,
    color: textColor,
    borderColor,
    ...style
  };

  return (
    <div
      className={`toast toast--${type} toast--${position} ${isVisible ? 'toast--visible' : ''} ${className}`}
      style={customStyles}
      onClick={onClick}
    >
      <div className="toast__content">
       <span className="toast__message">{message}</span>
        {/* {closable && (
          <button className="toast__close" onClick={handleClose}>
            ✕
          </button>
        )} */}
      </div>
      {showProgress && duration > 0 && (
        <div className="toast__progress">
          <div 
            className="toast__progress-bar" 
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
    </div>
  );
};

export default Toast;